import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "table-title"
}, "停车区管理", -1);
const _hoisted_2 = {
  style: {
    "height": "700px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_table_page = _resolveComponent("table-page");
  const _component_MapContainer = _resolveComponent("MapContainer");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, null, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_table_page, {
    fetchApi: _ctx.$api.business.park.getList,
    columns: $data.columns,
    topButtons: $data.topButtons,
    linkButtons: $data.linkButtons,
    searchItems: $data.searchItems,
    selectionEnable: false,
    ref: "tablePage"
  }, {
    toolBarLeft: _withCtx(() => [_hoisted_1]),
    _: 1
  }, 8, ["fetchApi", "columns", "topButtons", "linkButtons", "searchItems"]), _createVNode(_component_el_dialog, {
    title: "查看停车区域",
    "destroy-on-close": "",
    modelValue: $data.isAdd,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.isAdd = $event),
    width: "70%",
    center: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_MapContainer, {
      addressData: $data.address,
      type: $data.type,
      parkType: $data.parkType
    }, null, 8, ["addressData", "type", "parkType"])])]),
    _: 1
  }, 8, ["modelValue"])]);
}